exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex[data-v-31b6ce44] {\n  flex-direction: column;\n}\n@media screen and (max-width: 991px) {\n.d-flex[data-v-31b6ce44] {\n      flex-direction: row;\n}\n}\n", ""]);

// exports
